// extracted by mini-css-extract-plugin
module.exports = {"pdfBtn":"MammaPDF_pdfBtn__2erqo","pdfPrevBtn":"MammaPDF_pdfPrevBtn__uDgwr"};